import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { TrendingUp, Activity } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
const proofs = [{
  id: 1,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/tKrWHFVeA4oCxEnUFHkkBA/resultados_1.png',
  title: 'Facturación de 5 cifras',
  desc: 'Volumen de ventas neto superando los $58,000 USD. Resultados reales aplicando la metodología del programa.',
  accent: 'from-cyan-400 to-blue-600'
}, {
  id: 2,
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/nEGvR32MEk8jro6ej8nr5H/IMG_2693.MOV',
  title: 'Ventas en tiempo real',
  desc: 'Tráfico y conversiones constantes. Notificaciones de ventas en piloto automático directamente en tu tienda.',
  accent: 'from-purple-400 to-pink-600'
}, {
  id: 3,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/k7Bpua7yQnm2X3U9vL7xsX/resultados_3.png',
  title: 'Alta rentabilidad',
  desc: 'Volumen bruto de $66.7K USD. La ventaja de los productos digitales es su costo de producción casi nulo.',
  accent: 'from-emerald-400 to-green-600'
}, {
  id: 4,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/5vxiymLW99q2ALGR7hvwkD/resultados_2.png',
  title: 'Crecimiento sostenido',
  desc: 'Superando métricas mes a mes. Construye un ecosistema que genere ingresos recurrentes y escalables.',
  accent: 'from-amber-400 to-orange-600'
}];
export function VisualResults() {
  return <section className="py-24 px-4 bg-[#050510] relative overflow-hidden" data-id="element-353">
      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-354">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-cyan-900/10 rounded-full blur-[150px]" data-id="element-355" />
      </div>

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-356">
        {/* Section Header */}
        <ScrollReveal className="text-center mb-16" data-id="element-357">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-6" data-id="element-358">
            <TrendingUp className="w-4 h-4 text-green-400" data-id="element-359" />
            <span className="text-xs font-semibold uppercase tracking-widest text-green-400" data-id="element-360">
              Casos Reales
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight mb-4" data-id="element-361">
            No es teoría. <br data-id="element-362" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 via-cyan-400 to-purple-400" data-id="element-363">
              Son resultados comprobables.
            </span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-364">
            Esto es lo que sucede cuando dejas de perseguir seguidores y
            empiezas a construir activos digitales estructurados.
          </p>
        </ScrollReveal>

        {/* Grid de Resultados */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-365">
          {proofs.map((item, index) => <ScrollReveal key={item.id} delay={index * 0.15} direction="up" className="h-full" data-id="element-366">
              <div className="group relative h-full rounded-2xl bg-[#0c0c20] border border-white/10 overflow-hidden transition-all duration-500 hover:border-white/20 hover:shadow-[0_0_40px_rgba(0,212,255,0.1)] flex flex-col" data-id="element-367">
                {/* Media Container */}
                <div className="relative h-64 sm:h-72 overflow-hidden bg-white/5" data-id="element-368">
                  {item.type === 'video' ? <video src={item.src} autoPlay loop muted playsInline className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-369" /> : <img src={item.src} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-370" />}

                  {/* Gradient Overlay para fundir la imagen con la tarjeta oscura */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c20] via-[#0c0c20]/40 to-transparent opacity-90" data-id="element-371" />

                  {/* Accent Line */}
                  <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${item.accent} opacity-50 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-372" />
                </div>

                {/* Content */}
                <div className="p-6 md:p-8 flex-1 flex flex-col justify-center relative bg-[#0c0c20]" data-id="element-373">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-cyan-100 transition-colors" data-id="element-374">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-375">
                    {item.desc}
                  </p>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <SectionCTA headline="Tú puedes lograr resultados como estos" buttonText="EMPEZAR MI CAMINO — $16.39" data-id="element-376" />
      </div>
    </section>;
}